import React from 'react';

import ArticleBody from 'components/Article/ArticleBody';

import { MainMedia } from './MainMedia';
import { MediaCaption } from './MediaCaption';
import { Heading } from './Heading';
import { DuetLayout } from './DuetLayout';

import styles from './styles.module.scss';

const EXPANDABLEBYLINE_VERTICALS = ['today', 'select'];
/**
 * Returns the byline type for the article body based on the vertical.
 * @param {string} vertical - The vertical type of the article.
 * @returns {string} The byline type, either 'standard' or 'expandable'.
 */
const getArticleBodyBylineType = (vertical) => {
  if (!EXPANDABLEBYLINE_VERTICALS.includes(vertical)) {
    return 'standard';
  }
  return 'expandable';
};

/**
 * @param {object} props
 * @param {import('lib/graphqlTypeDefs.mjs').Article} props.article
 * @param {string} [props.path]
 * @param {import('lib/graphqlTypeDefs.mjs').VerticalType} props.vertical
 * @param {boolean} [props.isChromeless]
 * @param {boolean} [props.showCreatedDate]
 * @param {Function} [props.getRightRailAdConfig]
 * @param {boolean} [props.showUserActions]
 * @param {Function} [props.shouldRenderRightRailTaboola]
 * @returns {React.Element}
 */
export function ArticleDuet({
  article,
  path = '',
  vertical,
  isChromeless = false,
  showCreatedDate = true,
  getRightRailAdConfig = null,
  showUserActions = true,
  shouldRenderRightRailTaboola = null,
  showDecibelPlayer = false,
}) {
  const { primaryMedia } = article;

  return (
    <DuetLayout
      hasMainMedia={primaryMedia?.type === 'embeddedImage'}
      mainMedia={(
        <MainMedia primaryMedia={primaryMedia} />
      )}
      mediaCaption={(
        <MediaCaption primaryMedia={primaryMedia} />
      )}
      headingContent={(
        <Heading article={article} vertical={vertical} className="article-duet-layout--heading" />
      )}
      mainContent={(
        <ArticleBody
          vertical={vertical}
          article={article}
          index={0}
          path={path}
          isChromeless={isChromeless}
          showCreatedDate={showCreatedDate}
          shouldRenderRightRailTaboola={shouldRenderRightRailTaboola}
          shouldRenderTaboolaFeed
          getRightRailAdConfig={getRightRailAdConfig}
          showUserActions={showUserActions}
          showBylineTimestamp
          showInlineByline
          className={styles.articleDuetBody}
          bylineType={getArticleBodyBylineType(vertical)}
          showDecibelPlayer={showDecibelPlayer}
        />
      )}
    />
  );
}


export { getArticleBodyBylineType };
